@if (showDefaultTrigger) {
<div class="flex justify-start max-w-full overflow-x-auto py-1">
  <div
    role="tablist"
    class="daisy-tabs daisy-tabs-boxed w-fit shrink-0 flex flex-nowrap justify-center"
  >
    @for (item of tabsItems; track item; let i = $index) {
    <a
      role="tab"
      class="daisy-tab shrink-0 text-xs sm:text-sm whitespace-nowrap"
      [id]="'tab-' + item.name.toLowerCase()"
      [attr.aria-selected]="isSelected(i)"
      [class.daisy-tab-active]="isSelected(i)"
      (click)="changeSelection(i)"
      >{{ item.name | snakeToTitle }}</a
    >
    }
  </div>
</div>

}@else {
<section class="tabs-triggers" role="tablist">
  @for (item of tabsItems; track item; let i = $index) {
  <ng-container
    [ngTemplateOutlet]="item.tabsTrigger.templateRef || default_trigger"
    [ngTemplateOutletContext]="{
      $implicit: item,
      selectIndex: getChangeSelection(i),
      isSelected: isSelected(i),
      id: 'tab-' + item.name.toLowerCase()
    }"
  ></ng-container>
  }
</section>
}

<section class="tabs-contents">
  @for (item of tabsItems; track item; let i = $index) {
  <div
    class="tabs-content-block"
    [class.tab-selected]="selectedIndex === i"
    role="tabpanel"
    [id]="'panel-' + item.name.toLowerCase()"
    [attr.aria-labelledby]="'tab-' + item.name.toLowerCase()"
  >
    <ng-container
      [ngTemplateOutlet]="item.tabscontent.templateRef || default_content"
    ></ng-container>
  </div>
  }
</section>

<ng-template #default_trigger></ng-template>
<ng-template #default_content
  ><div><p>Default Content</p></div></ng-template
>
